import angular from 'angular';

angular.module('cloudX').directive('cxCheckbox', [
  '$timeout',
  '$q',
  '$parse',
  function($timeout, $q, $parse) {
    return {
      restrict: 'E',
      template:
        '<span title="{{tooltip}}" class="cx-checkbox" ng-class="{\'pointer\': !disabled}" ng-click="disabled ||saving || onClick($event)">' +
        "<i ng-class=\"{'glyphicon glyphicon-pencil':checked===null, 'fa fa-fw fa-check-square-o':checked, 'fa fa-fw fa-square-o':checked===false||checked===undefined, 'pointer': !disabled, 'greyed-out':disabled||saving}\"></i>" +
        '{{text}}' +
        '</span>',
      scope: {
        text: '@',
        tooltip: '@',
        checked: '=?value',
        checkedFunc: '&?',
        save: '&',
        onChange: '&',
        disabled: '=?',
      },
      link: function(scope, el, attrs) {
        if (typeof scope.checkedFunc === 'function') {
          scope.checked = scope.checkedFunc();
        }

        scope.onClick = function($event) {
          var checked = !scope.checked;

          //Disable when saving
          scope.saving = true;
          $event.stopPropagation();

          $timeout(function() {
            $q.when(
              scope.save({
                $data: checked,
              }),
            ).then(
              function(result) {
                scope.saving = false;
                if (typeof result === 'string') {
                  //error
                  return;
                } else if (typeof result === 'undefined' || !!result) {
                  //success update model
                  scope.checked = checked;
                }
              },
              function(error) {
                scope.saving = false;
              },
            );
          });

          $timeout(function() {
            $q.when(scope.onChange());
          });
        };
      },
    };
  },
]);
